import M from 'materialize-css/dist/js/materialize';
import React, { useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Breadcrumbs, Button, Input, ListPagination } from '../../../../components/UI/ComponentsUI';
import LinePickingService from '../../../../services/LinePickingService';
import { onValueChange, validateInputsRequired } from '../../../../utils/handleChangeHooks';
import { downloadFile, formatData, translate } from '../../../../utils/util';

const ReportFile = (props) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [instanceM, setInstanceM] = useState();
    const [data, setData] = useState([]);
    const [reportItems, setReportItems] = useState();
    const [filter, setFilter] = useState(
        {
            createdOn: "",
            fileName: "",
            orderCode: ""
        });

    useEffect(() => {
        if (reportItems?.items?.length > 0) {
            if (data.length > 0 && currentPage === 0) {
                setData(reportItems.items);
            } else {
                setData((prevState) => ([...prevState, ...reportItems.items]));
            }
        } else {
            setData([]);
        }
        // eslint-disable-next-line
    }, [reportItems?.items]);

    useEffect(() => {
        if (currentPage > 0) {
            onFilter();
        }
        // eslint-disable-next-line
    }, [currentPage]);

    useEffect(() => {
        const instance = M.Collapsible.init(document.querySelectorAll('.collapsible'), {
            accordion: false
        });
        setInstanceM(instance);
        return () => {
            setData([]);
            setReportItems();
        }
        // eslint-disable-next-line
    }, []);

    const onFilter = (click) => {
        var currentPageList = currentPage;
        if (validateInputsRequired("formsReport")) {
            if (click) {
                currentPageList = 0;
                setCurrentPage(0);
                setData([]);
            }
            props.getFileLog(filter, {
                PageSize: 25,
                PageIndex: currentPageList
            }, (data) => {
                setReportItems(data);
                instanceM[1].close();
            });
        }
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };


    const downloadReport = () => {
        props.getReport(filter, (data) => {
            downloadFile(data, `FileLog${Date.now()}.csv`, "data:text/csv", true);
        });
    }

    const getStatus = (item) => {

        if (item.success === true) {
            return translate('general:sucess');
        }
        else {
            return translate('line-picking:linepicking.fail');
        }
    }


    const renderItem = (item) => {
        return (
            <div className="row" key={item.id} style={{ marginBottom: '0px' }}>
                <ul className="col s12" style={{ padding: '0', marginTop: '0' }}>
                    <li
                        key={`oi-${item.id += 1}`}
                        style={{ backgroundColor: 'white', boxShadow: '0 1px 5px 0 rgba(0,0,0,0.2)', padding: '4px' }}
                    >

                        <div
                            className="row"
                            key={`${item.id}`}
                            style={{ backgroundColor: 'white', color: 'black', padding: '12px', display: 'block', marginBottom: '0px' }}
                        >

                            <div className="title black-text col s12" style={{ padding: '0px' }}>{`${translate('change-location:fileName')}: ${item.fileName}`}</div>
                            <div className="col s12" style={{ padding: '0px' }}>{`${translate('expedition:picking.orderCode')}: ${item.orderCode}`}</div>
                            <div className="col s7" style={{ padding: '0px' }}>{`${translate('change-location:message')}: ${item.message}`}</div>
                            <div className="col s7" style={{ padding: '0px' }}>{`${translate('change-location:createdBy')} ${item.createdBy}`}</div>
                            <div className="col s7" style={{ padding: '0px' }}>{`${translate('physical-confirmation:date')} ${formatData(item.createdOn)}`}</div>
                            <div className="col s7" style={{ padding: '0px' }}>{`${translate('general:status')}: ${getStatus(item)}`}</div>
                        </div>
                    </li>
                </ul >
            </div >
        )
    }

    return (
        <div>
            <Breadcrumbs id="reportTitle" title={{ icon: "mdi mdi-clipboard-list-outline", label: `${translate('line-picking:linepicking.fileReport')}` }} />
            <div className="container-fluid" style={{ marginTop: '20px' }}>
                <div className="container" style={{ marginTop: '0px' }}>
                    <ul id='collapsible' className="collapsible">
                        <li className='active'>
                            <div className="collapsible-header">
                                {translate('expedition:picking.filter')}
                            </div>
                            <div className="collapsible-body" style={{ padding: '10px' }}>
                                <div id="formsReport" className="row">
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            defaultValue={filter.createdOn}
                                            type="date"
                                            label={translate('physical-confirmation:date')}
                                            id="createdOn"
                                            name="createdOn"
                                            onChange={onChange}
                                        />
                                    </div>

                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="fileName"
                                            name='fileName'
                                            placeholder={translate('change-location:fileName')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <Input
                                            id="orderCode"
                                            name='orderCode'
                                            placeholder={translate('expedition:picking.orderCode')}
                                            type="text"
                                            onChange={onChange}
                                        />
                                    </div>
                                </div>
                                <div className="row" style={{ paddingTop: '5px' }}>
                                    <Button onClick={() => onFilter(true)} full="true" text={translate('delivery:general.search')} />
                                </div>
                            </div>
                        </li>
                    </ul>
                    {
                        data.length > 0 && navigator.userAgent !== 'logisticspwa' &&
                        <div className="row" style={{ paddingTop: '5px' }}>
                            <Button onClick={downloadReport} full="true" text={translate('general.generateReport')} />
                        </div>
                    }
                </div>
                <div id="list">
                    <ListPagination
                        disableRow={true}
                        page={reportItems?.totalPages}
                        current={{ currentPage, setCurrentPage }}
                        data={
                            data.map((item) => {
                                return renderItem(item);
                            })
                        }
                    />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = () => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFileLog: (filter, pagination, callback) => {
            dispatch(LinePickingService.getFileLog(filter, pagination, callback));
        },
        getReport: (filter, callback) => {
            dispatch(LinePickingService.getReportFileLog(filter, callback));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ReportFile)));
